import _axios from '@/utils/request'
const orderServices = {
    // 视频订单列表
    getOrderList (params) {
        return _axios('post', `/ms-shulan-hospital/v1/order/list`, params)
    },

    // 订单详情
    getOrderDetail (params) {
        return _axios('get', `/ms-shulan-hospital/v1/order/info`, params)
    },

    // 订单添加发票号
    postOrderNumber (params) {
        return _axios('post', `/ms-shulan-hospital/v1/order/saveInvoiceNumber`, params)
    },

    // 提现列表
    getWithdrawManagement (params) {
        return _axios('post', `/ms-shulan-hospital/wallet-withdraw/management`, params)
    },

    // 通过申请
    getWithdrawApprove (params) {
        return _axios('post', `/ms-shulan-hospital/wallet-withdraw/approve`, params)
    },

    // 拒绝申请
    getWithdrawRefuse (params) {
        return _axios('post', `/ms-shulan-hospital/wallet-withdraw/refuse`, params)
    },

    // 来源字典
    getOrign (param) {
        return _axios('get', `/ms-hoc-online-prescription/configs/all`, param)
    }

}

export default orderServices
